<template>
  <el-dialog title="修改成员" :visible.sync="show" width="700px" :close-on-press-escape="false"
    :close-on-click-modal="false">
    <div class="wrap">
      <el-form ref="ruleForm" :model="ruleForm" label-position="right" label-width="120px">
        <el-form-item class="form_item" label="姓名">{{
          ruleForm.userName
        }}</el-form-item>
        <el-form-item class="form_item" label="身份证号">{{
          ruleForm.identify
        }}</el-form-item>
        <el-form-item class="form_item_val" label="手机号" prop="mobile">
          <Desensitize :text="ruleForm.mobile" :dataType="1" :userId="ruleForm.userId" :clearText="true"
            :userType="2" />
        </el-form-item>

        <el-form-item class="form_item_val" label="角色">
          {{ ruleForm.roleName }}
        </el-form-item>
        <el-form-item class="form_item_val" label="直属上级">
          <el-select style="width: 160px" class="filter-item" v-model="ruleForm.topUserId" @change="editChange"
            size="small" clearable>
            <el-option v-for="(item, o) in topUserOptions" :key="o" :label="item.userName"
              :value="item.memberId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form_item_val" label="直属下级" width="400px">
          <div style="width: 300px">
            <el-checkbox-group v-model="ruleForm.downUserIds">
              <el-checkbox v-for="(item, i) in downUserOptions" :label="item.memberId" :key="i"
                v-show="item.memberId !== ruleForm.topUserId">{{ item.userName }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </el-form>
      <div class="modules">
        <el-tree :data="moduleLists" v-if="show" ref="tree" show-checkbox default-expand-all node-key="identify"
          :check-on-click-node="false" :expand-on-click-node="false" @check="nodeClick" :props="defaultProps">
        </el-tree>
      </div>
    </div>
    <span slot="footer">
      <el-button :loading="saveLoading" @click="handleSubmit" type="text" size="medium">保存</el-button>
      <el-button @click="show = false" type="text" size="medium">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      show: false,
      saveLoading: false,
      moduleLists: [], // 菜单tree列表
      userOptions: [], // 当前门店人员（过滤自己）
      topUserOptions: [], // 编辑时的上级数组
      downUserOptions: [], // 编辑时的下级数组
      selectedModules: [],
      defaultProps: {
        children: "nodes",
        label: "name",
      },
      ruleForm: {
        dealerId: '',
        userId: '',
        userName: '', // 姓名
        identify: '', // 身份证号
        mobile: '', // 手机号
        topUserId: '', // 直属上级
        downUserIds: [], // 直属下级
        roleName: '' // 角色
      },
    }
  },
  computed: {
  },
  watch: {
    visible(val) {
      this.show = val
      if (val) {
        this.initData()
        this.retrieveSystemData()
      }
    },
    show(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    initData() {
      this.topUserOptions = [];
      this.downUserOptions = [];
      this.ruleForm.topUserId = ''
      this.ruleForm.downUserIds = []
      const { dealerId, userId, userName, identify, mobile, roleName } = this.formData
      this.ruleForm.dealerId = dealerId
      this.ruleForm.userId = userId
      this.ruleForm.userName = userName
      this.ruleForm.identify = identify
      this.ruleForm.mobile = mobile
      this.ruleForm.roleName = roleName
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
      })

      this.formData.members.forEach((item) => {
        this.ruleForm.downUserIds.push(item.memberId);
      });
      if (this.formData.manager !== null) {
        this.ruleForm.topUserId = this.formData.manager.memberId;
      }
      this.getMemberList()
    },
    getMemberList() {
      this.$httpAuth
        .post("/v1/backendDealerRpc/memberList", {
          dealerId: this.ruleForm.dealerId,
        })
        .then((response) => {
          const data = response.data.data || [];
          this.userOptions = data.filter((item) => item.memberId !== this.ruleForm.userId);
          this.topUserOptions = JSON.parse(JSON.stringify(this.userOptions))
          this.downUserOptions = JSON.parse(JSON.stringify(this.userOptions))
          this.filterToUsers(this.ruleForm.topUserId);
          // 用户菜单选中
          this.setTreeSelectedVal()
        })
        .catch(() => { });
    },
    setTreeSelectedVal() {
      setTimeout(() => {
        if (this.formData.modules.indexOf(",") !== -1) {
          this.formData.modules.split(",").forEach((item) => {
            this.$refs.tree.setChecked(item, true);
          });
        } else if (this.formData.modules.indexOf(",") === -1 && this.formData.modules) {
          this.$refs.tree.setChecked(this.formData.modules, true);
        }
        this.selectedModules = this.$refs.tree
          .getCheckedKeys()
          .concat(this.$refs.tree.getHalfCheckedKeys());
      }, 100);
    },
    retrieveSystemData() {
      this.$httpAuth.post("/v1/baseRpc/info", {}).then((response) => {
        const { modules = [] } = response.data
        this.moduleLists = modules.filter(
          (item) =>
            !["智蛛锐见", "签到", "库存", "即客", "企业微信"].includes(
              item.name
            )
        );
      });
    },
    nodeClick(data, data1) {
      if (
        data.identify == "M_CUSTOMER_RESIGN" &&
        data1.checkedKeys.indexOf("M_CUSTOMER_RESIGN") == -1
      ) {
        this.$refs.tree.setChecked("M_CUSTOMER", true);
      }
      setTimeout(() => {
        this.selectedModules = this.$refs.tree
          .getCheckedKeys()
          .concat(this.$refs.tree.getHalfCheckedKeys());
      }, 0);
    },
    // 编辑时直属上级选择改变事件
    editChange() {
      this.downUserOptions = JSON.parse(JSON.stringify(this.userOptions));
      this.filterToUsers(this.ruleForm.topUserId);
      this.ruleForm.downUserIds = [];
    },
    // 过滤直属上级和直属上级的上级、直属上级的上级的上级...
    filterToUsers(id) {
      if (id !== "") {
        this.downUserOptions.forEach((item) => {
          if (id === item.memberId) {
            this.downUserOptions.splice(this.downUserOptions.indexOf(item), 1);
            if (item.manager !== null) {
              this.filterToUsers(item.manager.memberId);
            }
          }
        });
      }
    },
    handleSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.submitSave()
        }
      });
    },
    submitSave() {
      if (this.saveLoading) return;
      this.saveLoading = true;
      if (this.ruleForm.role == 7) {
        this.ruleForm.handleFront = true;
      }
      const { dealerId, userId, downUserIds, topUserId } = this.ruleForm
      this.$httpAuth
        .post("/v1/backendDealerRpc/memberUpdate", {
          dealerId,
          memberId: userId,
          modules: this.selectedModules.join(","),
          topUserId: String(topUserId),
          downUserIds: downUserIds
            .sort((a, b) => {
              return a - b;
            })
            .join(","),
        })
        .then(() => {
          this.show = false;
          this.$emit('editSuccess');
          this.$message({
            message: "保存成功",
            type: "success",
          });
        })
        .finally(() => {
          this.saveLoading = false;
        });
    }
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
}

.modules {
  width: 240px;
  height: 260px;
  overflow-y: auto;
}
</style>